<template>
  <div id="cover-spin"></div>
  <router-view />
</template>

<script>
export default {
  name: "app",
  title: "Aplikasi Jalan",
};
</script>
